
import inview from 'jquery-inview/jquery.inview';
import 'slick-carousel';


$(window).on('load', function () {
	if ($(window).width() < 993) {//tablet
		startInView();
	}
});


function startInView() {
	var theSection = $(".news-section");
	theSection.one('inview', function (e, visible) {
		if (visible == true) {
			var slider = $(this).find('.news'); //news wrapper
			initSlider(slider);
		}
	});
}


function initSlider(slider) {
	if (slider.length) {
		var slickConf = {
			dots: false,
			arrows: true,
			fade: false,
			infinite: false,
			rows: 0,
			slidesToShow: 2,
			slidesToScroll: 2,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						adaptiveHeight: true,
					},
				},
				{
					breakpoint: 576,
					settings: {
						adaptiveHeight: true,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		};
		slider.not('.slick-initialized').slick(slickConf);
	}
}
